import './Liveness.scss'
import React, { Component } from 'react'
import { Slide } from '@material-ui/core'
import {
    ButtonArrow,
    Status,
    Video,
    Demo,
    sdk,
    getBioDataFromVideo,
} from '@svort/component'
import {
    blobToBase64,
    isPortrait,
    isSafariIOs,
    delay
} from '../../utils/utils'
import axios from '../../utils/axios'
import { Translated } from '../../utils/translated'
import MediaRecorderError from '../../components/MediaRecorderError/MediaRecorderError'
import withMediaQuery from '../../HOC/withMediaQuery.js'

export class Liveness extends Component {

    constructor(props) {
        super(props);

        this.videoRef = React.createRef();
        this.videoChunks = [];

        this.state = {
            isDemo: false,
            isLiveness: false,

            isInit: false,
            isPrepare: false,
            isStarted: false,
            isPause: false,

            isChecking: false,

            isLoading: false,
            isError: false,
            status: '',
            onRetry: () =>
                this.setState({
                    isError: false
                }, () => this.checkSDKLoaded()),

            currentLiveness: null,

            isWhite: false,
            isBlack: false
        }

        this.baseRadius = Math.max(window.outerHeight, window.innerHeight) * 0.45 / 2;

        this.OnOrientationChange();
        window.addEventListener('orientationchange', () => this.OnOrientationChange());
    }

    OnOrientationChange() {
        // eslint-disable-next-line default-case
        switch (window.orientation) {
            case -90: this.orientation = -90; break;
            case 90: this.orientation = 90; break;
            case 0: this.orientation = 0; break;
            case 180: this.orientation = 180; break;
        }
    }

    componentDidMount() {
        if (window.MediaRecorder)
            this.setState({
                isDemo: true
            });
        else {
            this.setState({
                isMediaRecorderError: true,
            });
        }
    }

    componentWillUnmount() {
        if (this.ws) {
            this.ws.close();
            console.log('liveness WS closed');
        }

        // console.log('liveness SDK destructing');
        // sdk.destruct();
    }

    checkSDKLoaded = async () => {
        const isLoaded = await sdk.isLoaded();
        if (isLoaded) {
            this.setState({
                isInit: true,
                isLoading: true,
                status: 'permission_request'
            });
        } else this.setState({
            isLoading: true,
            isPureStatus: true,
            status: <Translated id="downloading_sdk" values={{ progress: 0 }} />
        }, () => sdk.setProgressListener((data) => {
            if (data.isLoaded) {
                this.setState({
                    isInit: true,
                    isPureStatus: false,
                    status: 'permission_request'
                });
            } else this.setState({
                status: <Translated id="downloading_sdk" values={{ progress: (data.currentProgress * 100 / data.dataSize).toFixed(1) }} />
            })
        }))
    }

    onVideoCanPlay = () => {
        this.setState({
            isInit: false,
            isLoading: false,
            isPrepare: true
        }, () => {
            this.getPhoto();
        });
    }

    onVideoError = (error, message) => {
        console.log('video_error:', error, message);

        this.setState({
            isInit: false,
            isLoading: false,
            isError: true,
            status: error
        });
    }

    onDemo = () => {
        this.setState({
            isDemo: false,
            isLiveness: true,
            direction: 'right'
        }, () => {
            this.checkSDKLoaded();
        });
    }

    onStartStop = async () => {
        // this.setState({
        //     isStarted: true
        // });
        await this.checkLivenessVideo();
    }

    recordVideo() {
        return new Promise(async (resolve) => {
            const chunks = [];
            this.mediaRecorder = new MediaRecorder(this.videoRef.current.srcObject);

            this.mediaRecorder.ondataavailable = (e) => {
                chunks.push(e.data)
            }
            this.mediaRecorder.onstop = async () => {
                const blob = new Blob(chunks);
                // console.log('blob:', blob.size);

                const base64 = await blobToBase64(blob);
                resolve(base64);
            }

            this.mediaRecorder.start(50);
            setTimeout(() => {
                // console.log(this.mediaRecorder.state);
                // console.log('chunks:', chunks.length);
                this.mediaRecorder.stop();
            }, 500);
        });
    }

    async getPhoto() {
        const { /* imageData, */ bioData } = await getBioDataFromVideo(this.videoRef.current);

        if (bioData /* && this.checkBorders(bioData.faceRect, imageData) */) {
            if (this.state.isPrepare) {
                await this.setStateSync({
                    isPrepare: false,
                    isStarted: true
                });
            } else if (this.state.isStarted) {
                // const photo = await imageDataToBase64(imageData);
                // console.log(photo);

                // await this.checkLiveness();
            }
        } else {
            this.setState({
                isPrepare: true,
                isStarted: false
            });
        }

        await delay(100);
        if (!this.state.isFinished && !this.state.isError && !this.state.isSuccess && !this.state.isLoading)
            this.getPhoto();
    }

    checkBorders = (faceRect, imageData) => {
        let isLeft, isRight, isBottom, isTop;

        this.isPortrait = isPortrait(imageData.width, imageData.height);
        const side = Math.min(imageData.width, imageData.height);
        const verticalSeverity = side * 0.05;
        const horizontalSeverity = side * 0.15;
        const { x, y, w, h } = faceRect;
        const x1 = x + w, y1 = y + h;

        const leftBorder = !this.isPortrait
            ? (imageData.width - imageData.height) / 2 + horizontalSeverity
            : horizontalSeverity;
        const rightBorder = !this.isPortrait
            ? imageData.width - (imageData.width - imageData.height) / 2 - horizontalSeverity
            : imageData.width - horizontalSeverity;
        const topBorder = !this.isPortrait
            ? verticalSeverity * 4
            : (imageData.height - imageData.width) / 2 + verticalSeverity * 4;
        const bottomBorder = !this.isPortrait
            ? imageData.height // - verticalSeverity
            : imageData.height - (imageData.height - imageData.width) / 2 // - verticalSeverity;

        isLeft = x < leftBorder || x > leftBorder + side * 0.15;
        isRight = x1 > rightBorder || x1 < rightBorder - side * 0.15;
        isBottom = y < topBorder || y > topBorder + verticalSeverity * 2;
        isTop = y1 > bottomBorder || y1 < bottomBorder - verticalSeverity * 2;

        // console.log(
        //     'isLeftMin:', x < leftBorder,
        //     'isLefMax:', x > leftBorder + side * 0.15,
        //     'isRightMin:', x1 > rightBorder,
        //     'isRightMax:', x1 < rightBorder - side * 0.15,
        //     'isBottomMin:', y < topBorder,
        //     'isBottomMax:', y > topBorder + verticalSeverity * 2,
        //     'isTopMin:', y1 > bottomBorder,
        //     'isTopMax:', y1 < bottomBorder - verticalSeverity * 2);

        if (isLeft || isRight || isBottom || isTop) {
            // if (!this.state.isBorderHint) {
            //     this.setState({
            //         isBorderHint: true,
            //         isCenterHint: false
            //     });
            //     this.updateStatus(this.props.onStatus('border_hint'));
            // }

            return false;
        } else {
            // if (this.state.isBorderHint) {
            //     this.setState({
            //         isBorderHint: false
            //     });
            //     this.updateStatus();
            // }

            return true;
        }
    }

    async checkLivenessVideo() {
        await this.setStateSync({ isWhite: true });
        await delay(500);

        const whiteVideo = await this.recordVideo();

        await this.setStateSync({
            isWhite: false,
            isBlack: true
        });
        await delay(500);

        const blackVideo = await this.recordVideo();

        await this.setStateSync({ isBlack: false });

        // if (bioDataWhite && bioDataBlack) {

        // console.log('white:', whiteVideo);
        // console.log('black:', blackVideo);

        if (!this.state.isChecking && whiteVideo && blackVideo) {
            await this.setStateSync({ isChecking: true });
            this.checkLiveness(blackVideo, whiteVideo);
        }
        // } else console.log('no data');
    }

    async checkLiveness(blackVideo, whiteVideo) {
        let video_rotation, video_ratio;
        if (isSafariIOs()) {
            video_rotation = this.orientation === 0 ? 90 : this.orientation === 90 ? 180 : 0;
            video_ratio = this.orientation === 0 ? 0.75 : 1.33;
        }

        const response = await axios.post('check_liveness', { videos: [blackVideo, whiteVideo], video_rotation, video_ratio });
        const { status, message, liveness } = response;

        if (status === 'success') {
            this.setState({
                isChecking: false,
                currentLiveness: liveness
            });
        } else if (status === 'error' && message === 'face_not_found') {
            this.setState({
                isChecking: false,
                currentLiveness: null
            });
        } else if (status === 'error') {
            this.setState({
                isPrepare: false,
                isStarted: false,
                isChecking: false,
                isError: true,
                status: `server_response_error_${message}`
            });
        }
    }

    setStateSync(state) {
        return new Promise(res => this.setState(state, res));
    }

    render() {
        const isMobile = this.props.mediaQuery;

        return (
            <div className={`liveness-wrapper${this.state.isBlack ? ' black' : ''}${this.state.isWhite ? ' white' : ''}`}>
                {!this.state.isMediaRecorderError && <div className='header'>
                    <p><Translated id='app.neural-flashes.title' /></p>
                </div>}

                <Demo
                    isShow={this.state.isDemo}
                    demoType={'liveness'}
                    onDemo={this.onDemo}
                    direction={this.state.direction || 'left'} />

                <Slide direction={'left'} in={this.state.isLiveness} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                    <div className={'liveness'}>
                        <Slide in={!this.state.isError} direction={'left'} timeout={600} mountOnEnter unmountOnExit>
                            <div className='content'>
                                <Video
                                    isInit={this.state.isInit}
                                    isShow={this.state.isPrepare || this.state.isStarted}
                                    isLiveness={true}
                                    isSquare={true}
                                    videoRef={this.videoRef}
                                    baseRadius={isMobile
                                        ? this.baseRadius * 1.45
                                        : this.baseRadius}

                                    onVideoCanPlay={this.onVideoCanPlay}
                                    onError={this.onVideoError} />

                                <div className='results-wrapper'>
                                    {(this.state.isPrepare || this.state.isStarted) &&
                                        <div className='result'>
                                            {this.state.isChecking
                                                ? <>
                                                    <p><Translated id='app.neural-flashes.processing' /></p>
                                                    <p><Translated id='app.neural-flashes.analyzing' /></p>
                                                </>
                                                : this.state.currentLiveness === null
                                                    ? <>
                                                        <p><Translated id='app.neural-flashes.keep-center' /></p>
                                                        <p><Translated id='app.neural-flashes.keep-center-hint' /></p>
                                                    </>
                                                    : <>
                                                        <p><Translated id='app.neural-flashes.results' /></p>
                                                        <p><Translated id='app.neural-flashes.live' />: <span>{(this.state.currentLiveness * 100).toFixed(2)}</span></p>
                                                        <p><Translated id='app.neural-flashes.fake' />: <span>{((1 - this.state.currentLiveness) * 100).toFixed(2)}</span></p>
                                                    </>}
                                        </div>}

                                    {!isMobile && this.state.currentLiveness !== null &&
                                        <ButtonArrow
                                            text={<Translated id='app.button.finish' />}
                                            onClick={() => this.props.history.push('/feature')} />}
                                </div>

                                {(this.state.isPrepare || this.state.isStarted) &&
                                    <div className='button-wrapper' style={{ width: this.baseRadius * 1.2 }}>
                                        <button
                                            onClick={this.onStartStop}
                                            className='btn-gradient'
                                            disabled={this.state.isPrepare || this.state.isChecking} >
                                            {this.isStarted
                                                ? <Translated id='app.neural-flashes.stop' />
                                                : <Translated id='app.neural-flashes.check' />}
                                        </button>
                                    </div>}

                                {isMobile && this.state.currentLiveness !== null &&
                                    <ButtonArrow
                                        text={<Translated id='app.button.finish' />}
                                        isArrow={!isMobile}
                                        onClick={() => this.props.history.push('/feature')} />}
                            </div>
                        </Slide>
                    </div>
                </Slide>

                <Slide in={this.state.isMediaRecorderError} direction={this.state.transitionDirection} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                    <div>
                        <MediaRecorderError
                            isShow={true} />
                    </div>
                </Slide>

                <Status
                    isShow={this.state.isLoading || this.state.isError}
                    isLoading={this.state.isLoading}
                    isError={this.state.isError}
                    isPure={this.state.isPureStatus}
                    onRetry={this.state.onRetry}>
                    {this.state.status}
                </Status>
            </div>
        )
    }
}

export default withMediaQuery('(max-width:600px)')(Liveness)

